import React from 'react';
import API from "../../api";
import {NavLink, withRouter} from "react-router-dom";
import {Helmet} from "react-helmet";
import {breakStringAfterLastComma, formatNumber, getCateringVariantInfo} from "../../helper";
import {images} from "../../constant";
import * as moment from "moment";
import {instanceOf} from "prop-types";
import {Cookies, withCookies} from "react-cookie";
import ShopHoursClass from "../Common/Timing";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExclamationTriangle, faUndo} from "@fortawesome/free-solid-svg-icons";

const PENDING_PAYMENT_STATUSES = [0, 3];
const REFUNDED_PAYMENT_STATUS = 2;

const api = new API();

class SuccessOrder extends React.Component {

    static propTypes = {
        cookies: instanceOf(Cookies).isRequired,
    };


    constructor(props) {
        super(props);
        this.state = {
            order_id: null,
            restaurant: null,
            preference_id: 1,//Pickup
            billing: null,
            shipping: null,
            transaction: null,
            order_detail: null,
            show: false,
            orders: [],
            total_amount: 0,
            sub_total: 0,
            total_tax: 0,
            discount : 0,
            status: 0,
            payment_status: null,
            refund_amount: null,
            default_preference: this.props.cookies.get('selected_preference') ? this.props.cookies.get('selected_preference') : 1, //Pickup
            fs_balance: 0,
            showDropdown: false
        },
            this.handleHomeRedirect = this.handleHomeRedirect.bind(this);
        this.handleTrackRedirect = this.handleTrackRedirect.bind(this);
    }

    componentDidMount() {

        if (this.props.match.params.order_id) {
            try {
                api.getSingleOrderByUUID(this.props.match.params.order_id).then(orders => {

                    if(orders.data.response.length < 1){
                        this.props.history.push({
                            pathname: '/'
                        });
                    }

                    this.setState({
                        preference_id: orders.data.response[0] ? orders.data.response[0].preference : "",
                        shipping: orders.data.response[0] ?
                            orders.data.response[0].shipping_address_1?.substring(0, orders.data.response[0].shipping_address_1.indexOf(',')) + ", " +
                            (orders.data.response[0].shipping_address_2 ? orders.data.response[0].shipping_address_2 + ", " : "") +
                            orders.data.response[0].shipping_address_1?.substring(orders.data.response[0].shipping_address_1.indexOf(',') + 1) + " " +
                            orders.data.response[0].shipping_zip_code
                            : "",
                        order_id: orders.data.response[0] ? orders.data.response[0].order_id : "",
                        order_detail: orders.data.response[0] ? orders.data.response[0] : "",
                        orders: orders.data.response[0] && orders.data.response[0].order_details ? orders.data.response[0].order_details : [],
                        total_amount: orders.data.response[0] ? orders.data.response[0].total_amount : 0,
                        sub_total: orders.data.response[0] ? orders.data.response[0].order_total : 0,
                        total_tax: orders.data.response[0] ? orders.data.response[0].total_tax : 0,
                        discount: orders.data.response[0] ? orders.data.response[0].total_coupon_discount : 0,
                        status: orders.data.response[0] ? orders.data.response[0].status : 0,
                        payment_status: orders.data.response[0] ? orders.data.response[0].payment_status : null,
                        refund_amount: orders.data.response[0]?.order_refund_queue?.length > 0
                            ? orders.data.response[0].order_refund_queue.reduce((total, refund) => total + parseFloat(refund.amount), 0)
                            : null,
                        fs_balance: orders.data.response[0] ? orders.data.response[0].ebt_fs_balance : 0,
                        transaction: orders.data.response[0] && orders.data.response[0].transaction ? orders.data.response[0].transaction : null,
                        restaurant: orders.data.response[0] && orders.data.response[0].restaurant_details ? orders.data.response[0].restaurant_details : null
                    })
                });
            } catch (e) {
                this.props.history.push({
                    pathname: '/'
                });
            }
        }
    }

    handleHomeRedirect() {
        this.props.history.push({
            pathname: '/'
        });
    }

    handleDropDownClick() {
        this.setState({
            showDropdown : true
        });
        setTimeout(() => {
            this.setState({
                showDropdown : false
            });
        }, 500)
    }

    handleTrackRedirect() {

        this.state.order_detail && this.state.order_detail.is_catering_order === 1 ?
            this.props.history.push({
                pathname: parseInt(this.state.default_preference) === 1 ? '/user/catering-pickup-orders' : '/user/catering-delivery-orders'
            }) :
            this.props.history.push({
                pathname: parseInt(this.state.default_preference) === 1 ? '/user/grocery-pickup-orders' : '/user/grocery-delivery-orders'
            });
    }

    render() {
        const {showDropdown} = this.state || {};
        const isPaymentPending = PENDING_PAYMENT_STATUSES.includes(this.state.payment_status);
        const isRefunded = this.state.payment_status === REFUNDED_PAYMENT_STATUS;
        return (
            <React.Fragment>
                <Helmet>
                    <title>
                        Order Success- Farmer&#039;s Fresh Meat: Houston Meat Market
                        &amp; Butcher Shop
                    </title>
                </Helmet>
                {/*<!-----------------main section----------------------->*/}

                {this.state.order_detail?.order_date &&
                <div className="container mb-5">
                    <div className="row">
                        <div className="col-12 col-md-8">
                            <div className="col-12 bg-white main-section successHead">
                                <div className="col-12 cart-heading py-0">
                                    <div className="row align-items-center">
                                        <div className="col-auto pr-0">
                                            {isPaymentPending ?
                                                <FontAwesomeIcon icon={faExclamationTriangle} className="check-img text-warning" size="2x"/>
                                                : isRefunded ?
                                                <FontAwesomeIcon icon={faUndo} className="check-img text-info" size="2x"/>
                                                :
                                                <img className="img-fluid check-img" src={images.checkIcon}/>
                                            }
                                        </div>
                                        <div className="col pl-md-0">
                                            <div className="col-12 title mb-1">
                                                <h2 className=" w-100">
                                                    {isPaymentPending ? "Payment Pending" : isRefunded ? "Order Refunded" : "Order Success"}
                                                </h2>
                                            </div>
                                            <div className="col-12 success-title p-0 pl-md-3">
                                                <p className="w-100 mb-0 text-dark">
                                                    <b className="font-weight-medium">Order number: </b>
                                                    <span className="font-weight-normal">#{this.state.order_detail ? this.state.order_detail.order_id : ""}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    {!isPaymentPending &&
                                    <div className="row align-items-center">
                                        <div className="col-md-auto pr-0 d-none d-md-block">
                                            <img className="img-fluid check-img opacity-0" src={images.success}/>
                                        </div>
                                        <div className="col ">
                                            <div
                                                className="p-0 col-12 success-title pt-md-2 mt-md-2 mt-3 pt-3 border-top border-theme">
                                                <p className="w-100 mb-md-1">
                                                    {this.state.order_detail && parseInt(this.state.preference_id) === 2 ?
                                                        <>
                                                            <b>Delivery at<span className="d-none d-md-inline-block">:</span> </b>
                                                            <span className="font-weight-normal">{this.state.shipping ? this.state.shipping : ""}</span>
                                                        </> :
                                                        <>
                                                            <b>Pickup location<span className="d-none d-md-inline-block">:</span> </b>
                                                            <span className="font-weight-normal">{this.state.restaurant ? this.state.restaurant.name : ""}</span>
                                                        </>
                                                    }
                                                </p>
                                                <p className="w-100 mb-0">
                                                     <span>
                                                             {this.state.order_detail && parseInt(this.state.preference_id) === 1 ?
                                                                 <>
                                                                     <b>Pickup time<span className="d-none d-md-inline-block">:</span> </b>
                                                                     <span className="font-weight-normal">{this.state.order_detail.order_date ? moment(this.state.order_detail?.order_date).format("LL") : ""}</span>
                                                                 </>
                                                                 :
                                                                 <>
                                                                     <b>Delivery time<span className="d-none d-md-inline-block">:</span> </b>
                                                                     <span className="font-weight-normal">{this.state.order_detail.order_date ? moment(this.state.order_detail?.order_date).format("LL") : ""}</span>
                                                                 </>
                                                             }
                                                    </span>

                                                    <span>
                                                             {this.state.order_detail && parseInt(this.state.preference_id) === 2 ?
                                                                 <>
                                                                     <span className="font-weight-normal"> at {this.state.order_detail ? this.state.order_detail.order_time_range : ""}</span>
                                                                 </>
                                                                 :
                                                                 <>
                                                                     <span className="font-weight-normal"> at {this.state.order_detail ? this.state.order_detail.order_time_range : ""}</span>
                                                                 </>
                                                             }
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>
                            <div className="bg-white main-section mb-m checkout-info">
                                {/*{ this.state.order_detail && parseInt(this.state.order_detail.preference_id) === 1 ?*/}
                                {/*    <>*/}
                                {/*        <div className="title mb-3">*/}
                                {/*            <h3 className="mb-0">Shipping Details</h3>*/}
                                {/*        </div>*/}
                                {/*        <div className="col-md-12 form-group">*/}
                                {/*            <form className="row g-3">*/}
                                {/*                <div className="col-md-6 fields">*/}
                                {/*                    <label*/}
                                {/*                        htmlFor="exampleInputFirstName"*/}
                                {/*                        className="form-label"*/}
                                {/*                    >*/}
                                {/*                        First Name*/}
                                {/*                    </label>*/}
                                {/*                    <span className="">{this.state.shipping ? this.state.shipping.first_name : "" }</span>*/}
                                {/*                </div>*/}

                                {/*                <div className="col-md-6 fields">*/}
                                {/*                    <label*/}
                                {/*                        htmlFor="exampleInputLastName"*/}
                                {/*                        className="form-label"*/}
                                {/*                    >*/}
                                {/*                        Last Name*/}
                                {/*                    </label>*/}
                                {/*                    <span className="">{this.state.shipping ? this.state.shipping.last_name : "" }</span>*/}
                                {/*                </div>*/}

                                {/*                <div className="col-md-6 fields">*/}
                                {/*                    <label*/}
                                {/*                        htmlFor="exampleInputEmail"*/}
                                {/*                        className="form-label"*/}
                                {/*                    >*/}
                                {/*                        Email address*/}
                                {/*                    </label>*/}
                                {/*                    <span className="">{this.state.shipping ? this.state.shipping.email : "" }</span>*/}
                                {/*                </div>*/}

                                {/*                <div className="col-md-6 fields">*/}
                                {/*                    <label*/}
                                {/*                        htmlFor="exampleInputPhone"*/}
                                {/*                        className="form-label"*/}
                                {/*                    >*/}
                                {/*                        Phone No.*/}
                                {/*                    </label>*/}
                                {/*                    <span className="">{this.state.shipping ? this.state.shipping.contact_number : "" }</span>*/}
                                {/*                </div>*/}
                                {/*                <div className="col-12 fields">*/}
                                {/*                    <label*/}
                                {/*                        htmlFor="exampleInputAddress"*/}
                                {/*                        className="form-label"*/}
                                {/*                    >*/}
                                {/*                        Street Address 1*/}
                                {/*                    </label>*/}
                                {/*                    <span className="">{this.state.shipping ? this.state.shipping.address_1 : "" }</span>*/}
                                {/*                </div>*/}
                                {/*                <div className="col-12 fields">*/}
                                {/*                    <label*/}
                                {/*                        htmlFor="exampleInputAddress"*/}
                                {/*                        className="form-label"*/}
                                {/*                    >*/}
                                {/*                        Street Address 2 (optional)*/}
                                {/*                    </label>*/}
                                {/*                    <span className="">{this.state.shipping ? this.state.shipping.address_2 : "" }</span>*/}
                                {/*                </div>*/}
                                {/*                <div className="col-md-4 fields">*/}
                                {/*                    <label*/}
                                {/*                        htmlFor="exampleInputCity"*/}
                                {/*                        className="form-label"*/}
                                {/*                    >*/}
                                {/*                        City*/}
                                {/*                    </label>*/}
                                {/*                    <span className="">{this.state.shipping ? this.state.shipping.city : "" }</span>*/}
                                {/*                </div>*/}

                                {/*                <div className="col-md-4 fields">*/}
                                {/*                    <label*/}
                                {/*                        htmlFor="exampleInputState"*/}
                                {/*                        className="form-label"*/}
                                {/*                    >*/}
                                {/*                        State*/}
                                {/*                    </label>*/}
                                {/*                    <span className="">{this.state.shipping ? this.state.shipping.state : "" }</span>*/}
                                {/*                </div>*/}

                                {/*                <div className="col-md-4 fields">*/}
                                {/*                    <label*/}
                                {/*                        htmlFor="exampleInputZip"*/}
                                {/*                        className="form-label"*/}
                                {/*                    >*/}
                                {/*                        Zip Code*/}
                                {/*                    </label>*/}
                                {/*                    <span className="">{this.state.shipping ? this.state.shipping.zip_code : "" }</span>*/}
                                {/*                </div>*/}
                                {/*            </form>*/}
                                {/*        </div>*/}
                                {/*        <hr/>*/}
                                {/*    </>*/}
                                {/*    : " "*/}
                                {/*}*/}

                                {/*<div className="title mb-3 mt-2">*/}
                                {/*    <h3 className="mb-0">Billing Details</h3>*/}
                                {/*</div>*/}
                                {/*<div className="col-md-12 form-group">*/}
                                {/*        <form className="row g-3">*/}
                                {/*            <div className="col-md-6 fields">*/}
                                {/*                <label*/}
                                {/*                    htmlFor="exampleInputFirstName"*/}
                                {/*                    className="form-label mb-0 text-muted"*/}
                                {/*                >*/}
                                {/*                    First Name*/}
                                {/*                </label>*/}
                                {/*                <span className="d-inline-block w-100 mb-2">{this.state.billing ? this.state.billing.first_name : ""}</span>*/}
                                {/*            </div>*/}

                                {/*            <div className="col-md-6 fields">*/}
                                {/*                <label*/}
                                {/*                    htmlFor="exampleInputLastName"*/}
                                {/*                    className="form-label mb-0 text-muted"*/}
                                {/*                >*/}
                                {/*                    Last Name*/}
                                {/*                </label>*/}
                                {/*                <span className="d-inline-block w-100 mb-2">{this.state.billing ? this.state.billing.last_name : ""}</span>*/}
                                {/*            </div>*/}

                                {/*            <div className="col-md-6 fields">*/}
                                {/*                <label*/}
                                {/*                    htmlFor="exampleInputEmail"*/}
                                {/*                    className="form-label mb-0 text-muted"*/}
                                {/*                >*/}
                                {/*                    Email address*/}
                                {/*                </label>*/}
                                {/*                <span className="d-inline-block w-100 mb-2">{this.state.billing ? this.state.billing.email : ""}</span>*/}
                                {/*            </div>*/}

                                {/*            <div className="col-md-6 fields">*/}
                                {/*                <label*/}
                                {/*                    htmlFor="exampleInputPhone"*/}
                                {/*                    className="form-label mb-0 text-muted"*/}
                                {/*                >*/}
                                {/*                    Phone No.*/}
                                {/*                </label>*/}
                                {/*                <span className="d-inline-block w-100 mb-2">{this.state.billing ? this.state.billing.contact_number : ""}</span>*/}
                                {/*            </div>*/}
                                {/*            <div className="col-12 fields">*/}
                                {/*                <label*/}
                                {/*                    htmlFor="exampleInputAddress"*/}
                                {/*                    className="form-label mb-0 text-muted"*/}
                                {/*                >*/}
                                {/*                    Address*/}
                                {/*                </label>*/}
                                {/*                <span className="d-inline-block w-100 mb-2">*/}
                                {/*                    { this.state.billing ? this.state.billing.address_1 : ""}, &nbsp;*/}
                                {/*                    { this.state.billing ? this.state.billing.address_2 : ""}, &nbsp;*/}
                                {/*                    { this.state.billing ? this.state.billing.city : ""}, &nbsp;*/}
                                {/*                    { this.state.billing ? this.state.billing.state : ""}, &nbsp;*/}
                                {/*                    { this.state.billing ? this.state.billing.zip_code : ""}*/}
                                {/*                </span>*/}
                                {/*            </div>*/}
                                {/*        </form>*/}
                                {/*    </div>*/}
                                <div className="title">
                                    <h3 className="mb-0">Payment details</h3>
                                </div>
                                <div className="col-md-12 form-group mb-0">
                                    <form className="row g-3">
                                        <div className="col-md-12 fields mb-0">
                                            {isPaymentPending &&
                                                <div className="badge badge-warning">Payment Pending</div>
                                            }
                                            {isRefunded &&
                                                <div className="badge badge-success mb-3">
                                                    Refunded{this.state.refund_amount !== null ? `: ${formatNumber(this.state.refund_amount)}` : ""}
                                                </div>
                                            }
                                            {!isPaymentPending && !!this.state.transaction?.length && this.state.transaction.map((item,index) => (
                                                <>
                                                <label
                                                    htmlFor="exampleInputLastName"
                                                    className="form-label mb-2 text-muted font-weight-medium"
                                                >
                                                    Card type: {item.card_type}
                                                </label>
                                                <div className="d-flex mb-3 align-items-center">
                                                    <span className="d-inline-block mr-3">
                                                    {
                                                        (() => {
                                                            if (item.card_type === "VISA")
                                                                return <img
                                                                    src={images.VisaIcon}
                                                                    alt="Visa"
                                                                />
                                                            else if (item.card_type === "MASTERCARD")
                                                                return <img
                                                                    src={images.MasterIcon}
                                                                    alt="MASTERCARD"
                                                                />
                                                            else if (item.card_type === "DISCOVER_DINERS")
                                                                return <img
                                                                    src={images.DDIcon}
                                                                    alt="DISCOVER_DINERS"
                                                                />
                                                            else if (item.card_type === "JCB")
                                                                return <img
                                                                    src={images.JcbIcon}
                                                                    alt="JCB"
                                                                />
                                                            else if (item.card_type === "AMERICAN_EXPRESS")
                                                                return <img
                                                                    src={images.AmericanIcon}
                                                                    alt="AMERICAN_EXPRESS"
                                                                />
                                                            else if (item.card_type === "EBT")
                                                                return <img
                                                                    width={'48px'}
                                                                    src={images.ebtH}
                                                                    alt="EBT"
                                                                />
                                                            else
                                                                return <img
                                                                    src={images.VisaIcon}
                                                                    alt="Visa"
                                                                />
                                                        })()
                                                    }
                                                </span>
                                                    <div
                                                        className="d-inline-flex justify-content-between align-items-center w-100 mb-0">
                                                        <div className="col-auto p-0">
                                                            **** **** **** {item ? item.masked_card_number : ""}
                                                            {item.card_type === "EBT" &&
                                                                <p className={'mb-0 text-muted'} style={{fontSize: '13px'}}>
                                                                    Remaining Balance: {formatNumber(this.state.fs_balance)}
                                                                </p>
                                                            }
                                                        </div>
                                                        <div className="col-auto p-0">
                                                            {item ? formatNumber(item.amount) : ""}
                                                        </div>
                                                    </div>
                                                </div>
                                                    {index !== 0 && index !== this.state.transaction.length - 1 && <hr />}
                                                </>
                                            ))}
                                        </div>
                                    </form>
                                </div>
                            </div>

                            {this.state.orders.length > 0 ?
                                <div className="row review-cart">
                                    <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                                        <div className="col-12 title">
                                            <h2>Your order</h2>
                                        </div>
                                        <div className="col-12 col-md-12 col-lg-12 col-xl-12 p-0">
                                            <div className="bg-white main-section mb-sm py-0">

                                                <div className="table-responsive cart-table">
                                                    <table className="table mb-0">
                                                        <tbody>
                                                        {this.state.orders.length > 0 ?
                                                            this.state.orders.map((item) => {
                                                                return (
                                                                    <tr className="table-row">
                                                                        <td className="image">
                                                                            <div className="contain">
                                                                                <img src={item?.item_image ? item.item_image : images.food} alt="food"/>
                                                                            </div>
                                                                        </td>
                                                                        <td className="name">
                                                                            <div className="contain">
                                                                                <NavLink
                                                                                    to={"/shop/" + item?.product?.slug}
                                                                                    exact>
                                                                                    <h6 className="fw-500">
                                                                                        {item['item_name']}
                                                                                        {item.product.item_type === 1 && (
                                                                                            <span className="fw-600 ml-1">X{item['item_count'] ? item['item_count'] : ""}</span>
                                                                                        )}
                                                                                    </h6>
                                                                                    <span className="text-black text- text-left fs-13 fw-500">
                                                                                        {(item.product && item.product.item_type !== 1) &&
                                                                                        <>{(item.variable?.unit?.name ?? "") === "pc" ? (parseInt(item.variable.weight * (item.item_count || 1)) + ' ' + (item.variable?.unit?.name ?? "")) :
                                                                                            <>
                                                                                                {/\d/.test(item.variable?.weight) ?
                                                                                                <>
                                                                                                    Total weight: {(item.variable?.weight?.includes('.00') ? item.variable?.weight?.split('.')[0] * (item.item_count || 1) : item.variable?.weight * (item.item_count || 1)) + " " + (item.variable?.unit?.name ?? "") }
                                                                                                </>
                                                                                                :
                                                                                                <>
                                                                                                    {item.variable?.weight * (item.item_count || 1)}
                                                                                                </>}
                                                                                            </>}
                                                                                        </>
                                                                                        }
                                                                                        {item.product && item.product.item_type === 1 && (() => {
                                                                                            const {label, value} = getCateringVariantInfo(item.variable);
                                                                                            return <span>{label}: <span className="text-capitalize">{value}</span></span>;
                                                                                        })()}
                                                                                        {item?.customization && ` (${item?.customization})`}
                                                                                    </span>

                                                                                </NavLink>
                                                                            </div>
                                                                        </td>
                                                                        {/*<td className="quantity">*/}
                                                                        {/*    <div className="num-block skin-5">*/}
                                                                        {/*        <div className="num-in no-change">*/}
                                                                        {/*            QTY : { item['quantity'] ? item['quantity'] : "" }*/}
                                                                        {/*        </div>*/}
                                                                        {/*    </div>*/}
                                                                        {/*</td>*/}
                                                                        <td className="price-details">
                                                                            <div className="food-content contain">
                                                                                {' '}
                                                                                <span className="each-price price-each d-none">${item['item_price'] ? item['item_price'].toFixed(2) : ""} each</span>
                                                                                <p className="price">
                                                                                    <span>{item['item_price'] ? formatNumber((item['item_price'] * item['item_count']).toFixed(2)) : ""}</span>
                                                                                </p>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            }) : ""}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : ""}
                        </div>

                        <div className="col-12 col-md-4 account-card ">
                            <div className="col-12 suc-stick">
                                <div className="bg-white main-section mb-sm mb-3 checkout-info">
                                    <div className="col-12 title p-0 mb-3 mt-1">
                                        <h2 className="mb-0 fs-9">Order details</h2>
                                    </div>
                                    <div className="main-cart">
                                        <div className="bg-white main-section p-0 border-0 order-view mb-0">
                                            <div className="col-12 order-total form-group mb-0 px-0">
                                                <ul className="border-0 p-0 mb-1">
                                                    <li className="pl-1">Subtotal <span>{formatNumber(this.state.order_detail ? this.state.order_detail.mrg_price_sub_total : 0)}</span>
                                                    </li>
                                                    {parseInt(this.state.total_tax) > 0 &&
                                                        <li className="pl-1">Tax <span>{formatNumber(this.state.total_tax)}</span>
                                                        </li>
                                                    }
                                                    {this.state.order_detail && parseInt(this.state.order_detail.preference) === 2 &&
                                                        <>
                                                        <li className="pl-1">Delivery
                                                            charge <span>{formatNumber(this.state.order_detail?.delivery_fee)}</span>
                                                        </li>
                                                        <li className="pl-1"> Driver tip
                                                        <span>{formatNumber(this.state.order_detail?.delivery_tip)}</span>
                                                        </li>
                                                        </>
                                                    }
                                                    {((this.state.order_detail?.mrg_price_sub_total - this.state.order_detail?.order_total) > 0 || this.state.discount > 0) &&
                                                        <>
                                                            <hr/>
                                                            <div className="col-12 title p-0 mb-3 mt-1">
                                                                <h2 className="mb-0 fs-9">Your savings</h2>
                                                            </div>
                                                        </>
                                                    }
                                                    {parseInt(this.state.order_detail?.mrg_price_sub_total - this.state.order_detail?.order_total) > 0 &&
                                                        <li className=" pl-1">Product discount <span
                                                            className="">{formatNumber(this.state.order_detail ? this.state.order_detail.mrg_price_sub_total - this.state.order_detail.order_total : 0)}</span>
                                                        </li>
                                                    }
                                                    {parseInt(this.state.discount) > 0 &&
                                                        <li className=" pl-1">Coupon discount <span
                                                            className="">{formatNumber(this.state.discount)}</span></li>
                                                    }

                                                    {((this.state.order_detail?.mrg_price_sub_total - this.state.order_detail?.order_total) > 0 || this.state.discount > 0) &&
                                                        <>
                                                            <li className=" text-success pl-1">Your total
                                                                savings <span>{formatNumber(this.state.order_detail ? (parseFloat(this.state.order_detail.mrg_price_sub_total - this.state.order_detail.order_total) + parseFloat(this.state.discount)) : 0)}</span>
                                                            </li>
                                                        </>
                                                    }
                                                    <hr/>
                                                    <li className="font-weight-bold">Total <span>{formatNumber(this.state.total_amount)}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 bg-white main-section mb-3">
                                    <div className="footer-content store-loc">
                                        <div className="col-12 title p-0">
                                            <h2>Store Details</h2>
                                        </div>
                                        {this.state.restaurant !== null ?
                                            <div className="contact-details">

                                                <div className="row">
                                                    <div className="col-auto pr-1">
                                                        <i className="fa fa-map-marker text-timing"
                                                           aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                    <div className="col-10 col-md-11 col-lg-10 col-xl-10 px-2">
                                                        <div className="p-0 hours-details">
                                                            <h6>
                                                                <h6 dangerouslySetInnerHTML={{ __html: breakStringAfterLastComma(this.state.restaurant.address) }}></h6>
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-auto pr-1">
                                                        <i className="fa fa-phone text-timing"></i>
                                                    </div>
                                                    <div className="col-10 col-md-11 col-lg-10 col-xl-10 px-2">
                                                        <div className="p-0 hours-details">
                                                            <h6>{this.state.restaurant ? this.state.restaurant.contact_number : ""}</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-auto pr-1">
                                                        <i
                                                            className="fa fa-clock-o text-timing"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </div>
                                                    <div className="col-10 col-md-11 col-lg-10 col-xl-10 px-2">
                                                        <div className="p-0 hours-details">
                                                            <h6 onClick={() => {
                                                                this.handleDropDownClick();
                                                            }} className='pointer text-timing'>Hours of Operation</h6>
                                                            <ShopHoursClass showDropdown={showDropdown}
                                                                shopOpenId='successOrderShopOpen'
                                                                shopCloseId='successOrderShopClose'
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            : ""}
                                    </div>
                                </div>
                                <div className="bg-white main-section py-3 btn-sec-suc">
                                    <div className="d-flex justify-content-center align-items-center">
                                        <button onClick={this.handleHomeRedirect}
                                                className="btn btn-m edit-button">Continue Shopping
                                        </button>
                                        {this.state.order_detail && parseInt(this.state.order_detail.preference) === 1 && this.state.order_detail.is_guest === 0 ?
                                            <button onClick={this.handleTrackRedirect} className="btn btn-order ">Track
                                                order</button> : ""
                                        }
                                        {/*{this.state.order_detail && parseInt(this.state.order_detail.preference) === 2 ?*/}
                                        {/*    <button onClick={() => {*/}
                                        {/*        window.open(this.state.order_detail?.order_delivery_address?.tracking_url, '_blank');*/}
                                        {/*    }} className="btn btn-proceed">Track order</button> : ""*/}
                                        {/*}*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </React.Fragment>
        );
    }
}

export default withRouter(withCookies(SuccessOrder))
